module.exports = __webpack_public_path__ + "static/media/tmnt.d838fb9c.mp3";